export default __webpack_public_path__ + "static/media/8.e40f6732.svg";